import { render, staticRenderFns } from "./instituto.vue?vue&type=template&id=9444d1fa&scoped=true"
import script from "./instituto.vue?vue&type=script&lang=js"
export * from "./instituto.vue?vue&type=script&lang=js"
import style0 from "./instituto.vue?vue&type=style&index=0&id=9444d1fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9444d1fa",
  null
  
)

export default component.exports